import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useInView } from 'react-intersection-observer';
import Loading from '../lib/loading';

const inViewPropertyTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
};

type InViewProperties = InferProps<typeof inViewPropertyTypes>;

const InView = ({ children, tag }: InViewProperties) => {
  const [reference, inView] = useInView({
    triggerOnce: true,
    rootMargin: '568px',
  });

  const HtmlTag = (
    tag ?? 'div'
  ) as React.ElementType;

  return (
    <HtmlTag ref={reference}>
      {
        inView ? children : <Loading />
      }
    </HtmlTag>
  );
};

InView.propTypes = inViewPropertyTypes;

export default InView;
